(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collectors-intensive"] && !Shopify.designMode) return;
  try {
    
(function () {
  const els = document.querySelectorAll('[data-si-countdown]');
  els.forEach((el) => {
    const raw = el.getAttribute('data-si-countdown');
    if (!raw) return;
    const target = new Date(raw).getTime();
    if (isNaN(target)) return;

    const d = el.querySelector('[data-d]');
    const h = el.querySelector('[data-h]');
    const m = el.querySelector('[data-m]');
    const s = el.querySelector('[data-s]');
    if (!d || !h || !m || !s) return;

    const pad = (n) => String(n).padStart(2, '0');

    const tick = () => {
      const diff = target - Date.now();
      if (diff <= 0) {
        el.classList.add('si-countdown--live');
        return false;
      }
      d.textContent = pad(Math.floor(diff / 86400000));
      h.textContent = pad(Math.floor((diff % 86400000) / 3600000));
      m.textContent = pad(Math.floor((diff % 3600000) / 60000));
      s.textContent = pad(Math.floor((diff % 60000) / 1000));
      return true;
    };

    if (!tick()) return;
    const id = setInterval(() => { if (!tick()) clearInterval(id); }, 1000);
  });
})();

(function () {
  const items = document.querySelectorAll('.si-faq-item');
  items.forEach((item) => {
    const btn = item.querySelector('.si-faq-item__question');
    const wrap = item.querySelector('.si-faq-item__answer-wrap');
    if (!btn || !wrap) return;

    const setOpen = () => {
      item.dataset.state = 'open';
      btn.setAttribute('aria-expanded', 'true');
      const target = wrap.scrollHeight;
      // ensure starting point is committed at 0 before animating to target
      wrap.style.height = '0px';
      void wrap.offsetHeight;
      requestAnimationFrame(() => {
        wrap.style.height = target + 'px';
      });
      const done = (e) => {
        if (e.propertyName !== 'height') return;
        wrap.style.height = 'auto';
        wrap.removeEventListener('transitionend', done);
      };
      wrap.addEventListener('transitionend', done);
    };

    const setClosed = () => {
      // capture current rendered height as a concrete px value so we can transition from it
      wrap.style.height = wrap.scrollHeight + 'px';
      void wrap.offsetHeight;
      requestAnimationFrame(() => {
        wrap.style.height = '0px';
      });
      const done = (e) => {
        if (e.propertyName !== 'height') return;
        item.dataset.state = 'closed';
        btn.setAttribute('aria-expanded', 'false');
        wrap.style.height = '';
        wrap.removeEventListener('transitionend', done);
      };
      wrap.addEventListener('transitionend', done);
    };

    btn.addEventListener('click', () => {
      if (item.dataset.state === 'open') setClosed();
      else setOpen();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sellers-intensive"] && !Shopify.designMode) return;
  try {
    
(function () {
  const els = document.querySelectorAll('[data-si-countdown]');
  els.forEach((el) => {
    const raw = el.getAttribute('data-si-countdown');
    if (!raw) return;
    const target = new Date(raw).getTime();
    if (isNaN(target)) return;

    const d = el.querySelector('[data-d]');
    const h = el.querySelector('[data-h]');
    const m = el.querySelector('[data-m]');
    const s = el.querySelector('[data-s]');
    if (!d || !h || !m || !s) return;

    const pad = (n) => String(n).padStart(2, '0');

    const tick = () => {
      const diff = target - Date.now();
      if (diff <= 0) {
        el.classList.add('si-countdown--live');
        return false;
      }
      d.textContent = pad(Math.floor(diff / 86400000));
      h.textContent = pad(Math.floor((diff % 86400000) / 3600000));
      m.textContent = pad(Math.floor((diff % 3600000) / 60000));
      s.textContent = pad(Math.floor((diff % 60000) / 1000));
      return true;
    };

    if (!tick()) return;
    const id = setInterval(() => { if (!tick()) clearInterval(id); }, 1000);
  });
})();

(function () {
  const items = document.querySelectorAll('.si-faq-item');
  items.forEach((item) => {
    const btn = item.querySelector('.si-faq-item__question');
    const wrap = item.querySelector('.si-faq-item__answer-wrap');
    if (!btn || !wrap) return;

    const setOpen = () => {
      item.dataset.state = 'open';
      btn.setAttribute('aria-expanded', 'true');
      const target = wrap.scrollHeight;
      // ensure starting point is committed at 0 before animating to target
      wrap.style.height = '0px';
      void wrap.offsetHeight;
      requestAnimationFrame(() => {
        wrap.style.height = target + 'px';
      });
      const done = (e) => {
        if (e.propertyName !== 'height') return;
        wrap.style.height = 'auto';
        wrap.removeEventListener('transitionend', done);
      };
      wrap.addEventListener('transitionend', done);
    };

    const setClosed = () => {
      // capture current rendered height as a concrete px value so we can transition from it
      wrap.style.height = wrap.scrollHeight + 'px';
      void wrap.offsetHeight;
      requestAnimationFrame(() => {
        wrap.style.height = '0px';
      });
      const done = (e) => {
        if (e.propertyName !== 'height') return;
        item.dataset.state = 'closed';
        btn.setAttribute('aria-expanded', 'false');
        wrap.style.height = '';
        wrap.removeEventListener('transitionend', done);
      };
      wrap.addEventListener('transitionend', done);
    };

    btn.addEventListener('click', () => {
      if (item.dataset.state === 'open') setClosed();
      else setOpen();
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
